import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBhlsDNEG14m81OQu8LSJErNAG3tVIPgyY",
  authDomain: "promptix-342e0.firebaseapp.com",
  projectId: "promptix-342e0",
  storageBucket: "promptix-342e0.firebasestorage.app",
  messagingSenderId: "5690385607",
  appId: "1:5690385607:web:031df3a08ffe92b293cae2",
  measurementId: "G-HLEX0TWXPC"
};

const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({ prompt: "select_account" });